import { Flex, List, Typography } from "antd";
import ModalWrapper from "../../generic/modal";
import Loader from "../../generic/Loader";
import { SmsDid } from "../../../interfaces/Did.type";
import { formatPhoneNumber } from "../../../utils/phoneLib";

const SmsProtocolDidModal = ({
  open,
  phone,
  dids,
  isLoading,
  onSelect,
  onClose,
}: {
  open: boolean;
  phone: string;
  dids: SmsDid[];
  isLoading?: boolean;
  onSelect: (did: string) => void;
  onClose: () => void;
}) => {
  return (
    <ModalWrapper
      title="Choose a number to send from"
      isModalOpen={open}
      setIsModalOpen={() => onClose()}
    >
      <Flex vertical style={{ padding: "16px 20px", maxHeight: "400px" }}>
        <Typography.Text style={{ marginBottom: 12, color: "#6b7280" }}>
          To: {formatPhoneNumber(phone) ?? phone}
        </Typography.Text>
        {isLoading ? (
          <Flex justify="center" align="center" style={{ minHeight: 120 }}>
            <Loader />
          </Flex>
        ) : (
          <List
            dataSource={dids}
            style={{ overflowY: "auto" }}
            locale={{ emptyText: "No numbers available" }}
            renderItem={(smsDid: SmsDid) => {
              const displayNumber = formatPhoneNumber(smsDid.did) ?? smsDid.did;
              const selectDid = () => onSelect(smsDid.did);

              return (
              <List.Item
                className="hoverable-did-item"
                role="button"
                tabIndex={0}
                aria-label={
                  smsDid.label
                    ? `Select ${displayNumber}, ${smsDid.label}`
                    : `Select ${displayNumber}`
                }
                onClick={selectDid}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    selectDid();
                  }
                }}
              >
                <Flex vertical>
                  <Typography.Text strong>
                    {formatPhoneNumber(smsDid.did) ?? smsDid.did}
                  </Typography.Text>
                  {smsDid.label && (
                    <Typography.Text type="secondary">{smsDid.label}</Typography.Text>
                  )}
                </Flex>
              </List.Item>
              );
            }}
          />
        )}
      </Flex>
    </ModalWrapper>
  );
};

export default SmsProtocolDidModal;
